<h1>Indexed mesh object</h1>
<canvas #canvasDocument class="canvas"></canvas>
<div>{{ fps }}</div>
